<template>
    <div class="row mb-3">
        <label :class="'col-form-label col-sm-' + labelCols" :for="field.formFieldId">{{ field.label }}{{
                field.required ? '*' : ''
            }}</label>
        <div :class="'col-sm-' + fieldCols">
            <div class="form-check form-switch">
                <input :id="field.formFieldId"
                       :checked="valueBool"
                       :disabled="field.locked"
                       :required="field.required"
                       class="form-check-input"
                       type="checkbox"
                       v-on:input="changeValue($event)"> <label :for="field.formFieldId"
                                                                class="form-check-label"></label>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        field: {
            type: Object,
            required: true
        },
        value: {
            type: String,
            required: false,
            defaultValue: ''
        },
        fieldCols: {
            type: String,
            required: true
        },
        labelCols: {
            type: String,
            required: true
        }
    },
    methods: {
        changeValue(e) {
            let value = e.target.checked ? 'True' : 'False';
            this.$emit('update:modelValue', {value: value})
        }
    },
    computed: {
        valueBool() {
            return this.value !== undefined && this.value === 'True';
        }
    }
}
</script>